import React, { useState, useEffect } from "react";
import * as actions from "../actions/index";
import Layouts from "../components/Layouts";
import LayoutsV2 from "../components/new-layouts";
import LayoutsRedBule from "@src/routes/routes-redBlue/components/RedBlueLayouts";
import { ISNEWROUTE } from '@src/utils/constant';
import { useDispatch } from "redux-react-hook";
import useMappedState from "@src/utils/useMappedState";
import { registerALabelClick } from "@src/utils/open-url-utils";

export default route => {
  const { component, auth, preload, layout, key, isStatic, leftSlider, path: routerPath } = route;
  const isNewRouter = localStorage.getItem(ISNEWROUTE) || 'false';

  if (preload !== false) {
    component?.();
  }

  return props => {
    const {
      match: { path }
    } = props;
    const { ready, userReady, siteReady, siteType = {} } = useMappedState("root");
    const dispatch = useDispatch();
    const newRouterList = [
      '/:type/wecode-v2',
      '/:type/appdetailV2/*',
      '/search',
      '/wecode/myconnectors',
      '/wecode/:type/romaList',
      '/wecode/:type/licenseInfo',
      '/wecode/connectorsdetail',
      '/wecode/:type/romaDetail',
      '/wecode/:type/romaEdit'
    ];

    const redBuleRouterList = [
      '/appList',
      '/appBaseInfo',
      '/memberManage',
      '/appApiManage',
      '/addAbility',
      '/versionRelease',
      '/versionDetail',
      '/approveManage',
      '/noPermission',
      '/appCapabilitiesList',
      '/appCapabilitiesEdit',
      '/capabilityManage',
      "/eventCallback",
      "/complaintManage",
      "/complaintDetail",
      "/projectConfiguration",
      "/entryGroupNotification",
      "/appCapabilitiesWecode",
      "/appCapabilitiesAddPush",
      "/operationManagement"
    ];

    const renderNewLayout = (path) => {
      if (isNewRouter === 'true' && newRouterList?.includes(path)) {
        MLayout = LayoutsV2;
      } else if (process.env.REACT_APP_WELINK_ENV === 'redBlue' && redBuleRouterList?.includes(path)) {
        MLayout = LayoutsRedBule;
      }
    };

    let MLayout = Layouts;
    if (typeof routerPath === 'string') {
      renderNewLayout(routerPath);
    } else if (Array.isArray(routerPath)) {
      path?.forEach(item => renderNewLayout(item));
    }

    const Loading = (
      <div id="nprogress">
        <div className="spinner">
          <div className="spinner-icon"></div>
        </div>
      </div>
    );
    const [Component, setComponent] = useState(null);
    const LazyComponent = async () => {
      const { default: Component } = await component();
      setComponent(
        <Component {...props} />
      );
    };
    useEffect(() => {
      LazyComponent();
      if (!siteReady) {
        dispatch(actions.getSiteTypeSagaAction());
      }
      // 获取用户信息
      if (auth && !ready) {
        dispatch(actions.getTenantInfoSagaAction());
        dispatch(actions.getTenantCheckisv()); //获取服务商是否是isv
      }
      if (auth && !userReady) {
        dispatch(actions.getUserInfoSagaAction());
      }
      if (siteReady) {
        document.title = siteType.site_type == 2 ? "HUAWEI CLOUD" : "HUAWEI CLOUD WeLink";
      }
    }, []);

    useEffect(() => {
      setTimeout(() => {
        registerALabelClick();
      }, 500);
    }, [window.location.href]);

    return (
      <MLayout {...props} layout={layout} path={path} componentKey={key} leftSlider={leftSlider}>
        {(auth && !userReady) || !Component ? (isStatic ? Component : Loading) : Component}
      </MLayout>
    );
  };
};
